// src/hooks/useLoadPlans.js
// Hook zum Laden von Plänen aus der Datenbank
import { useState, useEffect, useCallback } from "react";
import { fetchUserPlans } from '../api';

export default function useLoadPlans(user) {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadPlans = useCallback(async () => {
    if (!user?.username) {
      setPlans([]);
      return;
    }

    setLoading(true);
    setError(null);
    
    try {
      const result = await fetchUserPlans(user.username);
      
      if (result.error) {
        setError(result.error);
        setPlans([]);
      } else if (result.success) {
        setPlans(result.plans || []);
      } else {
        setError('Unerwartete Antwort vom Server');
        setPlans([]);
      }
    } catch (err) {
      console.error('Fehler beim Laden der Pläne:', err);
      setError('Verbindungsfehler beim Laden der Pläne');
      setPlans([]);
    } finally {
      setLoading(false);
    }
  }, [user?.username]);

  useEffect(() => {
    loadPlans();
  }, [loadPlans]);

  return {
    plans,
    loading,
    error,
    refresh: loadPlans
  };
}
